<template>
    <v-container fluid grid-list-md>
        <!-- intro ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
        <v-layout align-start justify-center>
            <v-flex>
                <v-card
                    class="mx-auto"
                    flat
                    pb-4>
                    <v-card-title>
                        <span class="text-uppercase body-1 font-weight-medium">Constraints</span>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <span class="caption">
                            Click the checkbox to enable or disable the constraint.  If enabled, provide a value.
                        </span>
                        <div class="flex-grow-1"></div>
                        <v-btn @click.native="onSave" small outlined color="primary">Save</v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-data-table
                            v-model="selected"
                            :headers="headers"
                            :items="constraints"
                            :single-select=false
                            :sort-by="['name']"
                            :sort-desc="[false]"
                            :items-per-page="15"
                            item-key="master_constraint_id"
                            show-select
                            multi-sort
                            >
                            <!-- header ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                            <template v-slot:top>
                            </template>
                            <!-- no-data ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                            <template slot="no-data" class="text-left">
                                <span class="subheading text-left">
                                    <v-icon color="orange">warning</v-icon>
                                    No constraint data assigned.
                                </span>
                            </template>
                            <!-- content  ~*~*~*~*~*~*~*~* -->
                            <template v-slot:item.name="{ item }">
                                <h3 class="subtitle-2 font-weight-medium">{{ item.name }}</h3>
                                <h3 class="caption">{{ item.description }}</h3>
                                <span v-if="!item.modifiable && isSelected(item)" class="caption font-italic primary--text">
                                This value is fixed and cannot be modified.
                                </span>
                            </template>
                            <template v-slot:item.value="{ item }">
                                <div v-if="isSelected(item)">
                                    <v-text-field v-if="item.modifiable" :value="item.value" v-model="item.value" class="text-left"></v-text-field>
                                    <v-text-field v-else :value="item.value" class="text-left" disabled></v-text-field>
                                </div>
                            </template>
                            <template v-slot:item.unit="{ item }">
                                <div v-if="isSelected(item)">
                                    {{ item.unit }}
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import ConstraintService from '@/services/ConstraintService'
import { mapGetters } from 'vuex'
export default {
  name: 'FacilityConstraints',
  data() {
    return {
      selected: [],
      constraints:[],
      headers: [
        //   { text: 'Id', align: 'left', sortable: true, value: 'master_constraint_id' },
          { text: 'Constraint', align: 'left', sortable: true, value: 'name' },
          { text: 'Value', align: 'left', sortable: true, value: 'value' },
          { text: 'Unit', align: 'left', sortable: true, value: 'unit' }
      ],
      masterConstraints: [],
      facilityConstraints: []
    }
  },
  computed: {
    ...mapGetters(['getFacilityId']),
  },
  created() {
    this.fetch()    
  },
  methods: {
    fetch() {
      ConstraintService.getConstraints()
        .then(response => {
          this.masterConstraints = []
          this.masterConstraints = response.data
          this.fetchFacilityConstraints()
        })
        .catch(error => { this.$toast.error("Error loading constraint data. " + error.message) })
    },
    fetchFacilityConstraints() {
      ConstraintService.getFacilityConstraints(this.getFacilityId)
        .then(response => {
          this.facilityConstraints = []
          this.facilityConstraints = response.data
          this.selected = []
          this.selected = response.data          
          // generate the master list for the table
          this.buildConstaints()
        })
        .catch(error => { this.$toast.error("Error loading constraint data. " + error.message) })
    },
    buildConstaints() {
      this.constraints = []
      for (var i = 0; i < this.masterConstraints.length; i++) {
        let mc = this.masterConstraints[i]
        let fc = this.findFacilityConstraint(mc.master_constraint_id)

        let obj = {
          master_constraint_id: mc.master_constraint_id,
          name: mc.name,
          description: mc.description,
          value: ((typeof fc != 'undefined') && (fc != undefined)) ? fc.value : mc.default_value,
          unit: mc.unit,
          modifiable: mc.modifiable
        }
        this.constraints.push(obj)

      }
    },
    findFacilityConstraint(id) {
      let fc = this.facilityConstraints.filter(function(constraint) {
        return constraint.master_constraint_id == id
      })
      return fc[0]
    },
    findConstraint(id) {
      let c = this.constraints.filter(function(constraint) {
        return constraint.master_constraint_id == id
      })
      return c[0]
    },
    isSelected(item) {
      let obj = this.selected.filter(function(constraint) {
        return  constraint.master_constraint_id == item.master_constraint_id
      })
      if ((typeof obj != undefined) && (obj != undefined) && (obj.length > 0) ) { return true }
      return false
    },
    onSave() { 
        for (var i = 0; i < this.selected.length; i++) {
            let o = this.selected[i]
            let con = this.findConstraint(o.master_constraint_id)
            let fc = this.findFacilityConstraint(o.master_constraint_id)

            // facility constraint exists, update
            if ((typeof fc != undefined) && (fc != undefined)) { 
                this.onUpdate(o, con.value)
                this.removeFacilityConstraint(o)
            }
            // facility constraint does not exists, add
            else {
                this.onAdd(o, con.value)
                this.removeFacilityConstraint(o)
            }
        }

        // whatever is left in facility constraints needs to be removed
        for (var x = 0; x < this.facilityConstraints.length; x++) {
            let o = this.facilityConstraints[x]
            this.onDelete(o)
            this.removeFacilityConstraint(o)        
        }

        // refresh
        this.facilityConstraints = this.selected
        // this.fetchFacilityConstraints()
        this.$toast.success("Constraints modified.")
    },
    removeFacilityConstraint(c) {
        for( var i = 0; i < this.facilityConstraints.length; i++){ 
            if ( this.facilityConstraints[i].master_constraint_id === c.master_constraint_id) {
                this.facilityConstraints.splice(i, 1); 
            }
        }
    },    
    async onAdd(constraint, val) {
      let obj = {
        master_constraint_id: constraint.master_constraint_id,
        facility_id: this.getFacilityId,
        value: val
      }
      ConstraintService.postFacilityConstraint(obj)
        // .then(response => { })
        .catch(error => { this.$toast.error("Error assigning constraint data. " + error.message) })
    },
    async onUpdate(constraint, val) {
      let obj = {
        master_constraint_id: constraint.master_constraint_id,
        facility_id: this.getFacilityId,
        value: val
      }
      ConstraintService.updateFacilityConstraint(obj)
        // .then(response => { } )
        .catch(error => { this.$toast.error("Error assigning constraint data. " + error.message) })
    },
    async onDelete(constraint) {
      let obj = {
        master_constraint_id: constraint.master_constraint_id,
        facility_id: this.getFacilityId,
        value: constraint.value
      }
      ConstraintService.deleteFacilityConstraint(obj)
        // .then(response => { } )
        .catch(error => { this.$toast.error("Error assigning constraint data. " + error.message) })
    }
  }
}
</script>
